// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"666":"16f5e3d8","688":"b23e0e0d"}[chunkId] + ".chunk.js";
};